import { render, staticRenderFns } from "./BuildingAddEditView.vue?vue&type=template&id=abe66906&scoped=true&"
import script from "./BuildingAddEditView.vue?vue&type=script&lang=js&"
export * from "./BuildingAddEditView.vue?vue&type=script&lang=js&"
import style0 from "./BuildingAddEditView.vue?vue&type=style&index=0&id=abe66906&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe66906",
  null
  
)

export default component.exports